import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import { MapPinIcon, PhoneIcon } from 'lucide-react';
import { business } from '../data/business';
import { PapelPicado } from './PapelPicado';
const ease = [0.23, 1, 0.32, 1] as const;
export function TruckHero() {
  const reduce = useReducedMotion();
  return <section id="top" aria-label="Oh My Tacos food truck" className="w-full bg-cream" data-id="element-111" data-mp="m4iyg6ohsk4w">
      <PapelPicado className="pt-2" count={24} data-id="element-112" data-mp="7gfxxct7y0nh" />
      <div className="mx-auto max-w-6xl px-4 pt-3 sm:px-6" data-id="element-113" data-mp="7elbfu2au0ha">
        <motion.div initial={reduce ? false : {
        opacity: 0,
        y: 12
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.3,
        ease
      }} className="relative overflow-hidden rounded-3xl bg-ink ring-4 ring-verde" data-id="element-114" data-mp="c869tn7t0wh0">
          <img src="https://cdn.magicpatterns.com/patterns/generated-images/73f9700b-e80f-4cc4-b2a0-293ea0757d52.jpg" alt="The green, white and red Oh My Tacos food truck with papel picado banners over its serving window" className="aspect-[4/3] w-full object-cover sm:aspect-[16/9] lg:aspect-[21/9]" data-id="element-115" data-mp="3knhlwi5bknf2" />
        </motion.div>

        <div className="flex flex-col gap-6 py-8 md:flex-row md:items-end md:justify-between md:py-10" data-id="element-116" data-mp="1nh6w7l7ccde8">
          <div className="max-w-2xl" data-id="element-117" data-mp="21chpwv9umsh0">
            <p className="font-display text-xl text-verde sm:text-2xl" data-id="element-118" data-mp="1wfixch5u2tkx">¡Bienvenidos a</p>
            <h1 className="font-display text-5xl leading-[0.95] text-salsa sm:text-6xl lg:text-7xl" data-id="element-119" data-mp="18polo2x93b29">
              Oh My Tacos!
            </h1>
            <p className="mt-3 text-lg text-muted sm:text-xl" data-id="element-120" data-mp="14q61xah61610">{business.tagline}</p>
          </div>

          <div className="flex flex-col gap-3 md:items-end" data-id="element-121" data-mp="1ihkjdcvfcz5y">
            <p className="inline-flex items-center gap-2 text-sm font-medium text-ink" data-id="element-122" data-mp="1dp17ckcdyc39">
              <span className="relative flex h-2.5 w-2.5" aria-hidden="true" data-id="element-123" data-mp="pz6vo63sytkl">
                <span className="absolute inline-flex h-full w-full animate-ping rounded-full bg-verde opacity-60 motion-reduce:animate-none" data-id="element-124" data-mp="l0lua3cte3uk" />
                <span className="relative inline-flex h-2.5 w-2.5 rounded-full bg-verde" data-id="element-125" data-mp="2l1tv5s2antyf" />
              </span>
              <span className="font-semibold text-verde" data-id="element-126" data-mp="2q0n6bdu3z8vf">Abierto hoy · Open today</span>
              <span className="text-muted" data-id="element-127" data-mp="2utpsv20gxi24">· {business.todayHours}</span>
            </p>
            <p className="inline-flex items-center gap-2 text-sm text-muted" data-id="element-128" data-mp="2zs13vg2i1ylx">
              <MapPinIcon className="h-4 w-4 text-salsa" aria-hidden="true" data-id="element-129" data-mp="22494cffyylb6" />
              {business.todayStop}
            </p>
            <div className="mt-1 flex flex-wrap gap-3" data-id="element-130" data-mp="27456e953w2o3">
              <a href={business.phoneHref} className="inline-flex items-center gap-2 whitespace-nowrap rounded-full bg-salsa px-6 py-3 font-bold text-white hover:bg-salsa-dark transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-salsa focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-131" data-mp="2c26pgu2j81zk">
                <PhoneIcon className="h-4 w-4" aria-hidden="true" data-id="element-132" data-mp="3rl0ddjk7wumw" />
                {business.phoneDisplay}
              </a>
              <a href="#menu" className="inline-flex items-center whitespace-nowrap rounded-full border-2 border-verde px-6 py-3 font-bold text-verde hover:bg-verde hover:text-white transition-colors duration-150 focus:outline-none focus-visible:ring-2 focus-visible:ring-verde focus-visible:ring-offset-2 focus-visible:ring-offset-cream" data-id="element-133" data-mp="1bu8nxray78aw">
                Ver el menú
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>;
}